import React from 'react';

const LoadingSpinner = ({ message = 'Carregando...' }) => {
  return (
    <div className="flex items-center justify-center p-6">
      <div className="flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        <p className="text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
